import MainRoutes from './MainRoutes';

export default MainRoutes;
